import React from "react";
import { cn } from "../../lib/utils";

// Keep every column-picker trigger on the same state-aware toolbar style.
const ColumnsButton = React.forwardRef(({ children, className, ...props }, ref) => (
  <button
    {...props}
    ref={ref}
    type={props.type || "button"}
    data-table-control="columns"
    className={cn(
      "inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 transition-colors",
      className
    )}
  >
    {children}
  </button>
));
ColumnsButton.displayName = "ColumnsButton";
export default ColumnsButton;
